import { Dayjs } from 'dayjs';

export class BaseModel {
  id = '';

  createdAt?: Dayjs = undefined;

  lastUpdatedAt?: Dayjs = undefined;
}
